import { InitialStateType } from '@/modules/AiAgents/context/nugzContext/context';
import { IGeneral } from '@/shared/types';

export enum AIActionsTypes {
  setMessagesList = 'SET_MESSAGES_LIST',
  setTableList = 'SET_TABLE_LIST',
  setIsLoading = 'SET_IS_LOADING',
  setIsEditing = 'SET_IS_EDITING',
  setAreaUnit = 'SET_AREA_UNIT',
}

type AIPayload = {
  [AIActionsTypes.setMessagesList]: InitialStateType['messagesList'];
  [AIActionsTypes.setTableList]: InitialStateType['tableList'];
  [AIActionsTypes.setIsLoading]: InitialStateType['isLoading'];
  [AIActionsTypes.setIsEditing]: InitialStateType['isEditing'];
  [AIActionsTypes.setAreaUnit]: InitialStateType['areaUnit'];
};

export type Actions =
  IGeneral.ActionMap<AIPayload>[keyof IGeneral.ActionMap<AIPayload>];

export const AIReducer = (state: InitialStateType, action: Actions) => {
  switch (action.type) {
    case AIActionsTypes.setMessagesList:
      return {
        ...state,
        messagesList: action.payload,
      };
    case AIActionsTypes.setTableList:
      return {
        ...state,
        tableList: action.payload,
      };
    case AIActionsTypes.setIsLoading:
      return {
        ...state,
        isLoading: action.payload,
      };
    case AIActionsTypes.setIsEditing:
      return {
        ...state,
        isEditing: action.payload,
      };
    case AIActionsTypes.setAreaUnit:
      return {
        ...state,
        areaUnit: action.payload,
      };

    default:
      return state;
  }
};
